import moment from "moment";
const dateTimeFormat1 = "YYYY-MM-DD HH:mm:ss";

function Calendar() {
  // do nothing
}

Calendar.format = function(date, format) {
  if (date) {
    return moment(Number(date)).format(format);
  } else {
    return "-";
  }
};

/**
 * 主要用于显示
 * 日期无效返回-
 */
Calendar.d1 = function(date) {
  return Calendar.d3(date, "-");
};

/**
 * 用于值处理后提交
 * 日期无效返回空字符串
 */
Calendar.d2 = function(date) {
  return Calendar.d3(date, "");
};

Calendar.d3 = function(date, defValue) {
  if (!date) return defValue;
  return moment(Number(date)).format(dateTimeFormat1);
};

Calendar.d4 = function(date, defValue) {
  if (!date) return defValue;
  return moment(Number(date)).format("YYYYMMDDHHmmss");
};

Calendar.d5 = function(date, defValue) {
  if (!date) return defValue;
  return moment(Number(date)).format("YYYY-MM-DD");
};

Calendar.d6 = function(date, defValue) {
  if (!date) return defValue;
  return moment(Number(date)).format("YYYY-MM-DD HH:mm");
};

Calendar.d7 = function(date, defValue) {
  if (!date) return defValue;
  return moment(date).format("0-HH-mm-00");
};

Calendar.d8 = function(date, defValue) {
  if (!date) return defValue;
  return moment(date).format("YYYY-MM-DD HH:mm");
};

/**
 * 获取某天0时0分0秒
 * moment().startOf('day')
 */
Calendar.startDate = function(value) {
  return moment(value).startOf("day");
};

/**
 * 获取某天0时0分0秒时间戳
 */
Calendar.startTime = function(value) {
  return moment(Calendar.startDate(value)).format("x");
};

/**
 * 获取当前时间
 */
Calendar.now = function(value) {
  return moment();
};

/**
 * 获取某天23时59分59秒
 */
Calendar.endDate = function(value) {
  return moment(value).endOf("day");
};

/**
 * 获取某天23时59分59秒时间戳
 */
Calendar.endTime = function(value) {
  return moment(Calendar.endDate(value)).format("x");
};

/**
 * 时间戳
 */
Calendar.timestamp = function(value) {
  return moment(value).format("x");
};

Calendar.month = function(date) {
  return moment(date).month();
};

/**
 * 获取某年1月1日0时0分0秒
 */
Calendar.startYear = function(value) {
  return moment(value).startOf("year");
};

/**
 * 获取某年12月31日23时59分59秒
 */
Calendar.endYear = function(value) {
  return moment(value).endOf("year");
};

/**
 * 获取某月月初0时0分0秒
 */
Calendar.startMonth = function(value) {
  return moment(value).startOf("month");
};

/**
 * 获取某月月末23时59分59秒
 */
Calendar.endMonth = function(value) {
  return moment(value).endOf("month");
};

/**
 * 获取某天某时0分0秒
 */
Calendar.startHour = function(value) {
  return moment(value).startOf("hour");
};

/**
 * 获取某天某时59分59秒
 */
Calendar.endHour = function(value) {
  return moment(value).endOf("hour");
};

/**
 * 获取某年之后时间
 */
Calendar.yearsLater = function(value, years) {
  return moment(value)
    .add(years, "Y")
    .format("YYYY-MM-DD");
};

/**
 * 获取昨天时间
 */
Calendar.yesterday = function() {
  return moment().subtract(1, "days");
};

Calendar.paddingZero = function(value) {
  if (value < 10) {
    return `0${value}`;
  } else {
    return value;
  }
};

export default Calendar;
export { dateTimeFormat1 };
